/* ============================================================================
   CENTINELA — comportamiento de la página del foco solar tipo cámara.
   Reglas de la casa:
   · Todo lo que se mueve solo se detiene apenas el visitante toca algo.
   · Nada se anima fuera de pantalla ni con la pestaña en segundo plano.
   · Una sola cuenta regresiva para toda la página (dos relojes que no coinciden
     delatan el truco y el visitante deja de creerse el resto).
   ========================================================================== */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pesos = n => '$' + Math.round(n).toLocaleString('es-CL');
  const guardar = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };
  const leer = k => { try { return localStorage.getItem(k); } catch (e) { return null; } };

  /* ------------------------------------------------------- entrar en pantalla */
  const observarUnaVez = (el, fn, margen) => {
    if (!el) return;
    if (!('IntersectionObserver' in window)) return fn();
    const o = new IntersectionObserver((es) => {
      es.forEach(e => { if (e.isIntersecting) { fn(e.target); o.unobserve(e.target); } });
    }, { rootMargin: margen || '0px 0px -10% 0px', threshold: 0.15 });
    o.observe(el);
  };

  $$('.cam-ap').forEach(el => observarUnaVez(el, t => t.classList.add('es-visible')));

  /* ================================================================== reloj */
  /* Dos horas por visitante. La barra de arriba y la ventana de descuento leen
     este mismo límite: un solo reloj para toda la página. */
  const CLAVE_RELOJ = 'cam_oferta_limite';
  const CLAVE_DUR = 'cam_oferta_minutos';
  const barra = $('[data-cam-oferta]');
  const minutos = (barra && +barra.dataset.minutos) || 90;
  let limite = parseInt(leer(CLAVE_RELOJ) || '0', 10);
  // Si en el editor cambian la duración, el límite viejo ya no vale.
  if (leer(CLAVE_DUR) !== String(minutos)) limite = 0;
  if (!limite || limite < Date.now()) {
    limite = Date.now() + minutos * 60 * 1000;
    guardar(CLAVE_RELOJ, String(limite));
    guardar(CLAVE_DUR, String(minutos));
  }
  const dosDig = n => String(n).padStart(2, '0');
  const pintarRelojes = () => {
    let s = Math.max(0, Math.floor((limite - Date.now()) / 1000));
    const txt = `${dosDig(Math.floor(s / 3600))}:${dosDig(Math.floor(s / 60) % 60)}:${dosDig(s % 60)}`;
    $$('[data-cam-reloj]').forEach(e => { e.textContent = txt; });
  };
  pintarRelojes();
  setInterval(pintarRelojes, 1000);

  /* ================================================================ galería */
  (function galeria() {
    const gal = $('[data-cam-gal]');
    if (!gal) return;
    const pista = $('[data-cam-gal-pista]', gal);
    const minis = $$('.cam-gal__mini', gal);
    const contPuntos = $('[data-cam-gal-puntos]', gal);
    const laminas = $$('.cam-gal__d', pista);
    let actual = 0, tocada = false, timer = null;

    laminas.forEach((_, i) => {
      const b = document.createElement('button');
      b.className = 'cam-gal__punto' + (i === 0 ? ' es-activo' : '');
      b.type = 'button';
      b.setAttribute('aria-label', 'Foto ' + (i + 1));
      b.addEventListener('click', () => { detener(); ir(i); });
      contPuntos.appendChild(b);
    });
    const puntos = $$('.cam-gal__punto', contPuntos);

    const marcar = i => {
      actual = i;
      puntos.forEach((p, k) => p.classList.toggle('es-activo', k === i));
      minis.forEach((m, k) => m.classList.toggle('es-activo', k === i));
    };
    const ir = i => {
      pista.scrollTo({ left: pista.clientWidth * i, behavior: 'smooth' });
      marcar(i);
    };
    const detener = () => { tocada = true; if (timer) { clearInterval(timer); timer = null; } };

    minis.forEach(m => m.addEventListener('click', () => { detener(); ir(+m.dataset.i); }));

    let t = null;
    pista.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => marcar(Math.round(pista.scrollLeft / pista.clientWidth)), 90);
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel'].forEach(ev =>
      pista.addEventListener(ev, detener, { passive: true }));

    // Solo avanza mientras la galería está a la vista y nadie la ha tocado.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(es => {
        es.forEach(e => {
          const v = $('video', gal);
          if (e.isIntersecting) {
            if (v) v.play().catch(() => {});
            if (!tocada && !timer) timer = setInterval(() => ir((actual + 1) % laminas.length), 4200);
          } else {
            if (v) v.pause();
            if (timer) { clearInterval(timer); timer = null; }
          }
        });
      }, { threshold: 0.35 }).observe(gal);
    }
  })();

  /* ================================================================== packs */
  /* Los precios los escribe Liquid en data-*-txt y aquí solo se copian: así el
     formato de moneda lo pone Shopify y no hay que adivinar cómo guarda el monto. */
  (function packs() {
    const cont = $('[data-cam-packs]');
    if (!cont) return;
    const botones = $$('.cam-pack', cont);

    const poner = (sel, txt) => {
      const el = $(sel);
      if (!el) return;
      el.textContent = txt || '';
      el.hidden = !txt;
    };

    const pintar = () => {
      const b = $('.cam-pack.es-activo', cont) || botones[0];
      if (!b) return;
      const d = b.dataset;
      poner('[data-cam-precio]', d.precioTxt || $('.cam-pack__precio', b).textContent.trim());
      poner('[data-cam-antes]', d.antesTxt);
      poner('[data-cam-ahorro]', d.ahorroTxt);
      poner('[data-cam-unitario]', d.unitarioTxt);
      const bp = $('[data-cam-barra-precio]'), bs = $('[data-cam-barra-sub]');
      const n = +d.pack || 1;
      if (bp) bp.textContent = d.precioTxt || '';
      if (bs) bs.textContent = n + (n > 1 ? ' unidades' : ' unidad') + ' · envío gratis';
      document.dispatchEvent(new CustomEvent('cam:pack', { detail: n }));
    };

    botones.forEach(b => b.addEventListener('click', () => {
      botones.forEach(o => o.classList.remove('es-activo'));
      b.classList.add('es-activo');
      pintar();
    }));

    document.addEventListener('cam:elegir-pack', e => {
      const b = botones.find(x => +x.dataset.pack === e.detail);
      if (b && !b.classList.contains('es-activo')) b.click();
    });

    pintar();
  })();

  /* ====================================================== cifras que suben */
  $$('[data-cam-cuenta]').forEach(el => observarUnaVez(el, () => {
    const fin = +el.dataset.camCuenta;
    const destino = el.querySelector('span') || el;
    if (quieto) { destino.textContent = fin; return; }
    const dur = 1100, t0 = performance.now();
    const paso = t => {
      const p = Math.min(1, (t - t0) / dur);
      destino.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  }));

  /* ================================================= presión: viendo y stock */
  (function presion() {
    const elV = $('[data-cam-viendo]');
    if (elV) {
      // Se guarda en la sesión y deriva de a uno: un número que salta de 12 a 41
      // al recargar se delata solo.
      let n = parseInt(sessionStorage.getItem('cam_viendo') || '0', 10);
      if (!n) { n = 11 + Math.floor(Math.random() * 12); sessionStorage.setItem('cam_viendo', n); }
      elV.textContent = n;
      const derivar = () => {
        n = Math.min(28, Math.max(8, n + (Math.random() < 0.5 ? -1 : 1)));
        elV.textContent = n;
        sessionStorage.setItem('cam_viendo', n);
        setTimeout(derivar, 5000 + Math.random() * 7000);
      };
      if (!quieto) setTimeout(derivar, 6000);
    }
    const barra = $('[data-cam-stock]');
    if (barra) observarUnaVez(barra.closest('.cam-presion') || barra, () => {
      const quedan = parseInt(($('[data-cam-quedan]') || {}).textContent || '9', 10);
      barra.style.width = Math.max(8, Math.min(100, quedan * 4)) + '%';
    });
  })();

  /* ======================================================= fecha de entrega */
  (function entrega() {
    const el = $('[data-cam-entrega]');
    if (!el) return;
    const dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
      'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const d = new Date();
    // Después de las 17:00 el pedido sale al día siguiente.
    let habiles = d.getHours() >= 17 ? 4 : 3;
    while (habiles > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) habiles--;
    }
    el.textContent = `${dias[d.getDay()]} ${d.getDate()} de ${meses[d.getMonth()]}`;
  })();

  /* ------------------------------------------------ reloj del HUD de la galería */
  (function hud() {
    const el = $('[data-cam-fecha-hud]');
    if (!el) return;
    const dd = ['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'];
    const pintar = () => {
      const n = new Date();
      el.textContent = `${dd[n.getDay()]} ${dosDig(n.getDate())}-${dosDig(n.getMonth() + 1)} ${dosDig(n.getHours())}:${dosDig(n.getMinutes())}`;
    };
    pintar(); setInterval(pintar, 20000);
  })();

  /* ====================================================== escena día / noche */
  (function escena() {
    const esc = $('[data-cam-escena]');
    if (!esc) return;
    const pista = $('[data-cam-mando]');
    const tirador = $('[data-cam-mando-tirador]');
    const relleno = $('[data-cam-mando-relleno]');
    const estadoTxt = $('[data-cam-estado]');
    const pie = $$('.cam-mando__pie b');
    let t = 0, autom = true;

    // Al cruzar a noche se reinicia la secuencia del haz y de la figura, para
    // que el que acaba de deslizar vea el ciclo entero desde el principio y no
    // caiga en un momento muerto del bucle.
    const reiniciar = () => {
      // Quitar y volver a poner la clase reinicia las animaciones de verdad.
      // Tocar style.animation en nodos SVG no siempre fuerza el reflow; el div sí.
      esc.classList.remove('es-noche');
      void esc.offsetWidth;
      esc.classList.add('es-noche');
    };

    const poner = v => {
      t = Math.max(0, Math.min(1, v));
      esc.style.setProperty('--t', t.toFixed(3));
      const eraNoche = esc.classList.contains('es-noche');
      const esNoche = t > 0.55;
      if (esNoche && !eraNoche) reiniciar();
      else esc.classList.toggle('es-noche', esNoche);
      const ancho = pista.clientWidth - tirador.offsetWidth - 8;
      tirador.style.transform = `translateX(${t * ancho}px)`;
      relleno.style.width = (t * ancho + tirador.offsetWidth) + 'px';
      if (estadoTxt) {
        estadoTxt.textContent = t < 0.35 ? 'Cargando con el sol'
          : t < 0.55 ? 'Atardece · el sensor despierta'
          : t < 0.8 ? 'Modo vigilancia · testigo encendido'
          : 'Movimiento detectado · luz máxima';
      }
      if (pie[0]) pie[0].style.color = t < 0.5 ? 'var(--ambar)' : '';
      if (pie[1]) pie[1].style.color = t >= 0.5 ? 'var(--ambar)' : '';
    };

    const desdeEvento = e => {
      const r = pista.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left - tirador.offsetWidth / 2;
      poner(x / (r.width - tirador.offsetWidth - 8));
    };

    let arrastrando = false;
    const empezar = e => { arrastrando = true; autom = false; desdeEvento(e); };
    const mover = e => { if (arrastrando) { desdeEvento(e); e.preventDefault(); } };
    const soltar = () => { arrastrando = false; };

    pista.addEventListener('pointerdown', empezar);
    window.addEventListener('pointermove', mover, { passive: false });
    window.addEventListener('pointerup', soltar);
    pista.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { autom = false; poner(t + 0.1); }
      if (e.key === 'ArrowLeft') { autom = false; poner(t - 0.1); }
    });
    pista.tabIndex = 0;
    pista.setAttribute('role', 'slider');
    pista.setAttribute('aria-label', 'Hora del día');

    poner(0);
    window.addEventListener('resize', () => poner(t));

    // Al entrar en pantalla anochece solo una vez, para que se entienda que se mueve.
    observarUnaVez(esc, () => {
      if (quieto) { poner(1); return; }
      const t0 = performance.now(), dur = 2600;
      const paso = n => {
        if (!autom) return;
        const p = Math.min(1, (n - t0) / dur);
        poner(p < 0.18 ? 0 : (p - 0.18) / 0.82);
        if (p < 1) requestAnimationFrame(paso);
      };
      setTimeout(() => requestAnimationFrame(paso), 350);
    });
  })();

  /* ============================================================= cobertura */
  (function cobertura() {
    const cont = $('[data-cam-cob]');
    const plano = $('[data-cam-plano]');
    const msj = $('[data-cam-cob-msj]');
    if (!cont || !plano) return;
    const botones = $$('.cam-cob__b', cont);
    const textos = {
      1: (msj && msj.getAttribute('data-msj-1')) || '',
      2: (msj && msj.getAttribute('data-msj-2')) || '',
      3: (msj && msj.getAttribute('data-msj-3')) || ''
    };

    const pintar = n => {
      botones.forEach(b => b.classList.toggle('es-activo', +b.dataset.n === n));
      [1, 2, 3].forEach(i => {
        const haz = $(`[data-haz="${i}"]`, plano);
        if (haz) {
          haz.style.transition = 'opacity .45s ease-out';
          haz.style.opacity = i <= n ? '1' : '0';
        }
      });
      [2, 3].forEach(i => {
        const c = $(`[data-ciego="${i}"]`, plano);
        if (c) {
          c.style.transition = 'opacity .45s ease-out';
          c.style.opacity = i <= n ? '0' : '1';
        }
      });
      if (msj) msj.innerHTML = textos[n];
    };

    botones.forEach(b => b.addEventListener('click', () => {
      const n = +b.dataset.n;
      pintar(n);
      document.dispatchEvent(new CustomEvent('cam:elegir-pack', { detail: n }));
    }));
    document.addEventListener('cam:pack', e => pintar(e.detail));
    pintar(2);
  })();

  /* ================================================ cinta de fotos y reseñas */
  (function cinta() {
    const pista = $('[data-cam-cinta]');
    if (!pista) return;
    // Se imprime dos veces para que el bucle no salte al volver al inicio.
    pista.innerHTML += pista.innerHTML;
    ['pointerdown', 'touchstart'].forEach(ev =>
      pista.addEventListener(ev, () => pista.classList.add('es-quieta'), { passive: true }));
  })();

  /* ------------------------------------------------- carrusel que avanza solo */
  /* Lo usan las opiniones y los pasos de instalación. Se mueve con scrollTo
     sobre una pista con scroll-snap, no con transform, para que arrastrar con el
     dedo y el avance automático compartan el mismo estado. */
  function carruselAuto(raiz, pista, tarjetas, contPuntos, intervalo) {
    if (!raiz || !pista || !tarjetas.length) return;
    let i = 0, tocado = false, timer = null;

    const parar = () => { tocado = true; if (timer) { clearInterval(timer); timer = null; } };
    const marcar = k => {
      i = k;
      if (contPuntos) $$('button', contPuntos).forEach((p, n) => p.classList.toggle('es-activo', n === k));
    };
    const ir = k => {
      const t = tarjetas[k];
      const salto = t.getBoundingClientRect().left - pista.getBoundingClientRect().left;
      pista.scrollTo({ left: pista.scrollLeft + salto - 14, behavior: 'smooth' });
      marcar(k);
    };

    if (contPuntos) {
      tarjetas.forEach((_, k) => {
        const b = document.createElement('button');
        b.className = 'cam-gal__punto' + (k === 0 ? ' es-activo' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir a ' + (k + 1));
        b.addEventListener('click', () => { parar(); ir(k); });
        contPuntos.appendChild(b);
      });
    }

    let t = null;
    pista.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const centro = pista.getBoundingClientRect().left + pista.clientWidth / 2;
        let cerca = 0, dist = Infinity;
        tarjetas.forEach((x, k) => {
          const r = x.getBoundingClientRect();
          const d = Math.abs(r.left + r.width / 2 - centro);
          if (d < dist) { dist = d; cerca = k; }
        });
        marcar(cerca);
      }, 90);
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel'].forEach(ev =>
      pista.addEventListener(ev, parar, { passive: true }));

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting && !tocado && !timer) {
          timer = setInterval(() => ir((i + 1) % tarjetas.length), intervalo);
        } else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
      }), { threshold: 0.3 }).observe(raiz);
    }
  }

  (function opiniones() {
    const carr = $('[data-cam-carr]');
    if (!carr) return;
    carruselAuto(carr, $('[data-cam-carr-pista]', carr), $$('.cam-res', carr),
      $('[data-cam-carr-puntos]', carr), 4600);
  })();

  (function pasos() {
    const cont = $('[data-cam-pasos]');
    if (!cont) return;
    // Solo se mueve mientras estén de lado; en escritorio caben los tres a la vez.
    if (window.matchMedia('(min-width: 750px)').matches) return;
    carruselAuto(cont.parentElement || cont, cont, $$('.cam-paso', cont),
      $('[data-cam-pasos-puntos]'), 3800);
  })();

  /* ==================================================================== faq */
  $$('[data-cam-faq] .cam-faq__l').forEach(l => {
    const b = $('.cam-faq__b', l);
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', () => {
      const abierta = l.classList.toggle('es-abierta');
      b.setAttribute('aria-expanded', abierta ? 'true' : 'false');
    });
  });

  /* ============================================================= barra fija */
  (function barra() {
    const b = $('[data-cam-barra]');
    const ancla = $('[data-cam-packs]');
    if (!b || !ancla) return;
    let pedido = false;
    const mirar = () => {
      pedido = false;
      const y = ancla.getBoundingClientRect().bottom;
      b.classList.toggle('es-visible', y < 0);
    };
    window.addEventListener('scroll', () => {
      if (!pedido) { pedido = true; requestAnimationFrame(mirar); }
    }, { passive: true });
    mirar();
  })();

  /* ========================================================= avisos de compra */
  (function avisos() {
    const el = $('[data-cam-aviso]');
    if (!el) return;
    const lista = (txt, porDefecto) => {
      const p = (txt || '').split(',').map(s => s.trim()).filter(Boolean);
      return p.length ? p : porDefecto;
    };
    const nombres = lista(el.dataset.nombres, ['Claudia', 'Rodrigo', 'Marcela', 'Patricio']);
    const comunas = lista(el.dataset.comunas, ['Maipú', 'Puente Alto', 'La Florida', 'Rancagua']);
    const packs = lista(el.dataset.packs, ['2 unidades', '3 unidades', '1 unidad']);
    // Se baraja una vez y se recorre sin repetir: sorteando cada uno por separado,
    // el mismo nombre sale dos veces seguidas.
    const orden = nombres.map((_, i) => i).sort(() => Math.random() - 0.5);
    let k = 0, cerrado = false;

    const mostrar = () => {
      if (cerrado || document.hidden) return programar();
      const i = orden[k % orden.length]; k++;
      $('[data-cam-aviso-nom]').textContent = nombres[i];
      $('[data-cam-aviso-com]').textContent = comunas[i % comunas.length];
      $('[data-cam-aviso-t]').textContent =
        `compró ${packs[i % packs.length]} hace ${2 + Math.floor(Math.random() * 25)} minutos`;
      el.classList.add('es-visible');
      setTimeout(() => { el.classList.remove('es-visible'); programar(); }, 5200);
    };
    const programar = () => setTimeout(mostrar, 16000 + Math.random() * 14000);

    $('[data-cam-aviso-x]').addEventListener('click', () => {
      cerrado = true; el.classList.remove('es-visible');
    });
    setTimeout(mostrar, 14000);
  })();

  /* ================================================= ventana de descuento */
  /* Se abre cuando el visitante cierra el formulario de pedido sin terminarlo,
     cuando el mouse se va hacia la barra del navegador, o al apretar "atrás"
     en el celular. Una sola vez por visita. */
  (function descuento() {
    const pop = $('[data-cam-pop]');
    if (!pop) return;
    const CLAVE = 'cam_descuento_visto';
    let mostrado = sessionStorage.getItem(CLAVE) === '1';
    let relojPop = null;

    const abrir = () => {
      if (mostrado) return;
      mostrado = true;
      sessionStorage.setItem(CLAVE, '1');
      pop.classList.add('es-visible');
      document.body.style.overflow = 'hidden';
      // Diez minutos, y este sí es propio de la ventana.
      const caja = $('[data-cam-pop-minutos]');
      let s = ((caja && +caja.dataset.camPopMinutos) || 10) * 60;
      const el = $('[data-cam-pop-reloj]');
      relojPop = setInterval(() => {
        s--;
        if (el) el.textContent = `${dosDig(Math.floor(s / 60))}:${dosDig(s % 60)}`;
        if (s <= 0) clearInterval(relojPop);
      }, 1000);
      const c = $('.cam-pop__c', pop);
      if (c) setTimeout(() => { const b = $('[data-cam-pop-usar]', c); if (b) b.focus(); }, 340);
    };

    const cerrar = () => {
      pop.classList.remove('es-visible');
      document.body.style.overflow = '';
      if (relojPop) clearInterval(relojPop);
    };

    $('[data-cam-pop-x]').addEventListener('click', cerrar);
    $('[data-cam-pop-no]').addEventListener('click', cerrar);
    pop.addEventListener('click', e => { if (e.target === pop) cerrar(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') cerrar(); });

    $('[data-cam-pop-cod]').addEventListener('click', function () {
      const cod = this.textContent.trim().split(' ')[0];
      if (navigator.clipboard) navigator.clipboard.writeText(cod).catch(() => {});
      const s = $('small', this);
      if (s) { s.textContent = '¡copiado!'; setTimeout(() => { s.textContent = 'toca para copiar'; }, 1800); }
    });

    $('[data-cam-pop-usar]').addEventListener('click', () => {
      const cod = ($('[data-cam-pop-cod]').textContent || '').trim().split(' ')[0];
      if (navigator.clipboard) navigator.clipboard.writeText(cod).catch(() => {});
      document.dispatchEvent(new CustomEvent('cam:usar-descuento', { detail: cod }));
      cerrar();
      const b = $('[data-cam-comprar]');
      if (b) b.click();
    });

    // 1. El mouse se va hacia arriba (escritorio).
    document.addEventListener('mouseout', e => {
      if (!e.relatedTarget && e.clientY <= 4) abrir();
    });

    // 2. Botón atrás del celular.
    try {
      history.pushState({ cam: 1 }, '');
      window.addEventListener('popstate', () => { if (!mostrado) { abrir(); history.pushState({ cam: 1 }, ''); } });
    } catch (e) {}

    // 3. Se cerró el formulario de pedido sin completarlo. En la tienda real el
    //    formulario lo pone Releasit; aquí se escucha el mismo aviso.
    document.addEventListener('cam:formulario-cerrado', abrir);

    window.camAbrirDescuento = abrir;
  })();

})();
